
import { Component, Vue } from 'vue-property-decorator';
import DataTableOfContents from '@/components/DataTab/DataTableOfContents.vue';
import DataTabChart from '@/components/DataTab/DataTabChart.vue';
import { AreaType, ScenarioType, SectorType, FilterPayloadType } from '@/types';

@Component({
  components: {
    DataTableOfContents,
    DataTabChart,
  },
})
export default class DataPanel extends Vue {
  chartSelection = 'radio-1';

  get selectedArea(): AreaType | null {
    return this.$store.getters.selectedArea;
  }

  get selectedScenarios(): ScenarioType[] {
    return this.$store.getters.selectedScenarios;
  }

  get selectedSector(): SectorType | null {
    return this.$store.getters.selectedSector;
  }

  get appliedFilters(): FilterPayloadType {
    return this.$store.getters.appliedFilters;
  }

  get showSelectMessage(): boolean {
    return !this.appliedFilters.area ||
      !this.appliedFilters.sector ||
      !this.appliedFilters.scenarios
      ? true
      : false;
  }
}
